import React from "react";
import { Button, TextField } from "@material-ui/core";
import { Grid as MUIGrid } from "@mui/material";
import { Autocomplete } from "@material-ui/lab";
import { FilterList, Clear } from "@material-ui/icons";

const FilterPanel = ({
  filterPanel,
  onFilterChange,
  onSearch,
  onClearFilters,
  unidadesOptions,
  formasCobrancaOptions,
  cirurgioesOptions,
  loadingUnidades,
  loadingFormasCobranca,
  loadingCirurgioes,
  bplidOptions,
  loadingBplids
}) => (
  <div className="ibox">
    <div className="ibox-title" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 15px' }}>
      <FilterList style={{ color: '#3f51b5' }} />
      <span style={{ fontWeight: 600, color: '#3f51b5' }}>Filtros</span>
    </div>
    <div className="ibox-content" style={{ paddingBottom: 8 }}>
      <MUIGrid container spacing={2} alignItems="flex-end">
        <MUIGrid item xs={12} md={3}>
          <Autocomplete
            options={[
              { value: 'CUSTOMIZED', label: 'PERSONALIZADO' },
              { value: 'STANDARDIZED', label: 'PADRONIZADO' },
              { value: 'DOR', label: 'DOR' }
            ]}
            getOptionLabel={(opt) => opt.label || ''}
            value={filterPanel.BusinessUnit || null}
            onChange={(_, val) => onFilterChange('BusinessUnit', val)}
            renderInput={(params) =>
              <TextField {...params} label="Business Unit" variant="outlined" size="small" />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={3}>
          <Autocomplete
            options={unidadesOptions}
            loading={loadingUnidades}
            getOptionLabel={(opt) => opt.name || ''}
            value={filterPanel.Unidade}
            onChange={(_, val) => onFilterChange('Unidade', val)}
            renderInput={(params) =>
              <TextField {...params} label="Unidade" variant="outlined" size="small" />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={3}>
          <Autocomplete
            options={formasCobrancaOptions}
            loading={loadingFormasCobranca}
            getOptionLabel={(opt) => opt.name || ''}
            value={filterPanel.FormaCobranca}
            onChange={(_, val) => onFilterChange('FormaCobranca', val)}
            renderInput={(params) =>
              <TextField {...params} label="Forma Cobrança" variant="outlined" size="small" />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={3}>
          <Autocomplete
            options={cirurgioesOptions}
            loading={loadingCirurgioes}
            getOptionLabel={(opt) => opt.name || ''}
            value={filterPanel.Cirurgiao}
            onChange={(_, val) => onFilterChange('Cirurgiao', val)}
            renderInput={(params) =>
              <TextField {...params} label="Cirurgião" variant="outlined" size="small" />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={3}>
          <Autocomplete
            options={bplidOptions}
            loading={loadingBplids}
            getOptionLabel={(opt) => opt.name || ''}
            value={filterPanel.BPLID}
            onChange={(_, val) => onFilterChange('BPLID', val)}
            renderInput={(params) =>
              <TextField
                {...params}
                label="BPLID"
                variant="outlined"
                size="small"
                onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
              />
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={3}>
          <TextField
            label="Data Início — De"
            type="date"
            variant="outlined"
            size="small"
            fullWidth
            value={filterPanel.StartDateFrom}
            onChange={(e) => onFilterChange('StartDateFrom', e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={3}>
          <TextField
            label="Data Início — Até"
            type="date"
            variant="outlined"
            size="small"
            fullWidth
            value={filterPanel.StartDateTo}
            onChange={(e) => onFilterChange('StartDateTo', e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </MUIGrid>
        <MUIGrid item xs={12} md={3} style={{ display: 'flex', gap: 8 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<FilterList />}
            onClick={onSearch}
            fullWidth
            style={{ height: 40 }}
          >
            Buscar
          </Button>
          <Button
            variant="outlined"
            startIcon={<Clear />}
            onClick={onClearFilters}
            fullWidth
            style={{ height: 40 }}
          >
            Limpar
          </Button>
        </MUIGrid>
      </MUIGrid>
    </div>
  </div>
);

export default FilterPanel;
